import type { CityConfig } from "../city-template/types";

export const westlandConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — marriage license issuance" },
    { label: "Divorce Records — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Westland",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "westland",
  route: "/cities/westland",
  title: "Emergency Passport Westland, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Westland, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Westland, Wayne, Garden City, Inkster, and western Detroit metro residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Westland, MI",
  heroSubtitle: "Westland and western Wayne County travelers trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Located between Detroit Metro Airport (DTW) and downtown Detroit, our courier service connects you directly to the Detroit Passport Agency without the downtown drive or appointment wait. A+ BBB rated serving all of western Detroit metro.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20commercial%20district%20in%20Westland%20Michigan%20with%20Warren%20Road%20shopping%20corridor%2C%20strip%20malls%20and%20local%20businesses%2C%20tree-lined%20sidewalks%2C%20warm%20afternoon%20sunlight%2C%20American%20suburban%20atmosphere%2C%20autumn%20foliage%2C%20parked%20cars%20along%20the%20street%2C%20no%20text%20no%20people%2C%20realistic%20photography%20style%2C%20warm%20earth%20tones%2C%20clean%20and%20welcoming%20suburban%20environment&width=1800&height=700&seq=westland-hero-001&orientation=landscape",
  heroImageAlt: "Westland Michigan suburban commercial district along Warren Road with warm afternoon light",
  geoPosition: "42.3242;-83.4002",
  geoPlacename: "Westland, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 20 miles east of Westland — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Westland", zips: "48185, 48186" },
    { name: "Wayne", zips: "48184" },
    { name: "Garden City", zips: "48135, 48136" },
    { name: "Inkster", zips: "48141" },
    { name: "Romulus", zips: "48174" },
    { name: "Taylor", zips: "48180" },
    { name: "Dearborn Heights", zips: "48125, 48127" },
    { name: "Livonia", zips: "48150, 48151, 48152, 48153, 48154" },
    { name: "Canton", zips: "48187, 48188" },
    { name: "Redford", zips: "48239, 48240" },
    { name: "Dearborn", zips: "48120, 48121, 48123, 48124, 48125, 48126, 48128" },
    { name: "Plymouth", zips: "48170" },
    { name: "Farmington", zips: "48331, 48332, 48333, 48334, 48335, 48336" },
    { name: "Northville", zips: "48167, 48168" },
    { name: "Novi", zips: "48374, 48375, 48376, 48377" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-car-line", title: "Central Location", desc: "Westland sits between DTW and downtown — convenient shipping from anywhere" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS or FedEx in Westland or metro" },
  ],
  internalLinks: [
    { name: "Expedited passport in Livonia, MI", route: "/cities/livonia" },
    { name: "Emergency passport services in Detroit, MI", route: "/cities/detroit" },
    { name: "Urgent passport services in Canton, MI", route: "/cities/canton-mi" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Westland, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Westland residents can ship from the UPS Store on Warren Road or any FedEx location in the western metro area.",
  fpcOfficeDistance: "Serving Westland, Wayne, Garden City, Inkster, Romulus, Taylor, Dearborn Heights, Livonia, Canton, Redford, and all of western Wayne County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Westland and the western Detroit metro area. From the Warren Road commercial corridor to the neighborhoods near Hines Park, from the Canton border to the Garden City line — we serve all of western Wayne County. Our courier service eliminates the need to drive downtown and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Westland and all western Wayne County communities including Wayne, Garden City, Inkster, Romulus, Taylor, Dearborn Heights, Livonia, Canton, Redford, Dearborn, Plymouth, Farmington, Northville, and Novi. We also serve travelers departing from Detroit Metro Airport (DTW) who need emergency passports.",
  howItWorksIntro: "Most Westland travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Westland and western metro residents often discover passport issues just before flights from DTW or planned international trips. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Westland and western Wayne County travelers — from automotive workers to retail managers to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Westland, MI? Here are the most common ones we hear from western Wayne County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Westland travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute flights, family emergencies, and business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Ideal for DTW departures and all international travel"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Westland adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Westland-area address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Westland residents and families — including new citizens, young professionals, and families in the western metro communities.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Westland residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Westland-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Westland and western Wayne County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Westland MI", description: "Urgent passport processing for Westland Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Westland MI", description: "Fast passport renewal for Westland Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Westland MI", description: "New passport application services for Westland Michigan residents applying for their first passport." },
    { name: "Child Passport Westland MI", description: "Minor passport services for Westland Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Lisa M.",
      location: "Westland, MI",
      rating: 5,
      text: "Cruise to the Bahamas in 4 days and realized my passport had expired. I was freaking out. Fast Passport Center handled the renewal in 2 days. Shipped from the UPS on Warren Road and had it back before I packed my bags. Amazing service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Kevin R.",
      location: "Garden City, MI",
      rating: 5,
      text: "Business conference in London with 6 days notice. I live in Garden City and work in Canton — no time to drive downtown for an agency appointment. Fast Passport Center made it happen. Their courier handled everything while I was at work.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia H.",
      location: "Westland, MI",
      rating: 5,
      text: "Three passports for our family trip to Mexico — two renewals and one first-time for my daughter. Fast Passport Center was incredibly patient, answered all my questions, and got everything done in 5 days. Worth every penny.",
      service: "Family Passport Bundle",
    },
    {
      name: "Darnell J.",
      location: "Inkster, MI",
      rating: 5,
      text: "Had to fly to Jamaica for my grandmother's funeral with 3 days notice. Lost my passport during a move. Fast Passport Center had a replacement in my hands in 48 hours. I made the flight and the funeral. Forever grateful.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "westland-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20 miles east of Westland — downtown Detroit",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "westland-2",
      name: "Westland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35000 Warren Rd",
      city: "Westland",
      state: "MI",
      zip: "48185",
      phone: "(734) 728-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Westland — on Warren Road near the Wayne border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Westland acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for Westland, Wayne, and Garden City residents.",
      icon: "ri-mail-line",
    },
    {
      id: "westland-3",
      name: "Garden City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31000 Maplewood St",
      city: "Garden City",
      state: "MI",
      zip: "48135",
      phone: "(734) 421-7800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Garden City — approximately 3 miles east of Westland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Garden City and eastern Westland residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "westland-4",
      name: "Inkster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27505 Michigan Ave",
      city: "Inkster",
      state: "MI",
      zip: "48141",
      phone: "(313) 277-3830",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Inkster — approximately 4 miles north of Westland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Inkster, Westland, and Garden City residents. Book early — high demand during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "westland-5",
      name: "Livonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "33600 Five Mile Rd",
      city: "Livonia",
      state: "MI",
      zip: "48154",
      phone: "(734) 542-5500",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Livonia — approximately 6 miles northeast of Westland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Livonia, Farmington, Redford, and northern Westland communities. Ample parking available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Westland" },
    { feature: "DTW Departure Expertise", agency: "No tailored advice", fpc: "Yes — we know DTW timelines and requirements" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Westland residents often discover passport issues just before their international trip. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many western Wayne County travelers use a passport card or enhanced license for Canada driving trips — but these are not valid for international flights. If you fly from DTW, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Westland-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-plane-line",
      title: "Not Checking International Entry Requirements",
      description: "Different countries have different passport validity requirements. Some require 6 months validity beyond your return date. Always verify before booking your DTW flight.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Westland or western Wayne County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Westland, Livonia, or near DTW." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Westland-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Westland, MI?", a: "Fast Passport Center offers emergency passport processing in Westland, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive downtown." },
    { q: "Where is the closest passport acceptance facility to Westland?", a: "The Westland Post Office at 35000 Warren Rd is the primary local acceptance facility. The Garden City Post Office on Maplewood St and the Inkster Post Office on Michigan Ave are also convenient options. All require appointments — book 1–2 weeks in advance." },
    { q: "Do I need to go to the Detroit Passport Agency myself?", a: "No. Fast Passport Center's registered couriers go to the Detroit Passport Agency for you. You simply complete your application online and ship your documents. Our couriers handle the rest — no downtown drive, no parking, no appointment wait." },
    { q: "Can I get a passport quickly if I live near Detroit Metro Airport?", a: "Absolutely. Westland is just 15 minutes from DTW, making our expedited service ideal for last-minute international flights. Ship your documents from any UPS or FedEx in Westland or near the airport." },
    { q: "What airports do Westland-area travelers use?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 15 minutes from Westland. DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other destinations. Windsor Airport (YQG) is a secondary option for Canada travel." },
    { q: "How much does an expedited passport cost in Westland, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Westland residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Westland and western Wayne County offer passport photos. The UPS Store on Warren Road and FedEx Office locations also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve all of western Wayne County?", a: "Yes. Fast Passport Center serves all of western Wayne County including Westland, Wayne, Garden City, Inkster, Romulus, Taylor, Dearborn Heights, Livonia, Canton, Redford, Dearborn, Plymouth, Farmington, Northville, and Novi. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
  ],
  photoLocations: [
    { name: "Walgreens — Westland", address: "35500 Warren Rd, Westland, MI 48185", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Westland", address: "37625 Warren Rd, Westland, MI 48185", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Westland", address: "35000 Warren Rd, Westland, MI 48185", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Livonia", address: "29555 Plymouth Rd, Livonia, MI 48150", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Westland", address: "32500 Warren Rd, Westland, MI 48185", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Livonia", address: "17111 Laurel Park Dr, Livonia, MI 48152", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Livonia, Farmington, Redford, and northern Wayne County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "15–20 minutes from Westland via I-96 or I-275",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "30–35 minutes from Westland via I-96 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Westland travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};